const TimeProgressBarComponent = {
  restrict: 'E',
  template: require('./time-progress-bar.html'),
  bindings: {
    dateStart: '<',
    dateEnd: '<'
  },
  controllerAs: 'vm',
  controller: TimeProgressBarController
};

function TimeProgressBarController($timeout) {
  'ngInject';
  var vm = this;
  var timer;

  vm.$onInit = function () {
    var totalRange = moment.range(vm.dateStart, vm.dateEnd);
    vm.max = totalRange.diff('milliseconds');
    runTimer();
  };

  vm.$onDestroy = function () {
    $timeout.cancel(timer);
  };

  function runTimer() {
    timer = $timeout(function () {
      vm.progress = moment.range(vm.dateStart, new Date()).diff('milliseconds');
      runTimer();
    }, 1000);
  }
}

export default TimeProgressBarComponent;